import { FontFamily } from '@euler/components/typography';
import { formatDateTime } from '@euler/utils/formatters';
import { memo, useEffect, useState } from 'react';
import { StyleProp, View, ViewStyle } from 'react-native';
import { BehaviorSubject } from 'rxjs';
import styled from 'styled-components/native';

export const ImageWatermark = memo(
  ({
    title,
    subTitle,
    author,
    location,
    scale = 1,
    style,
  }: {
    title: string;
    subTitle: string;
    author: string;
    location: string;
    scale?: number;
    style?: StyleProp<ViewStyle>;
  }) => {
    return (
      <View
        css={`
          background-color: rgba(0, 0, 0, 0.25);
          padding: ${6 * scale}px;
          align-items: flex-end;
        `}
        style={style}
      >
        <Label
          css={`
            font-size: ${18 * scale}px;
            line-height: ${20 * scale}px;
            font-family: ${FontFamily.NotoSans.Regular};
          `}
        >
          {title}
        </Label>
        <Label
          css={`
            font-size: ${12 * scale}px;
            margin-top: ${4 * scale}px;
            margin-bottom: ${10 * scale}px;
            line-height: ${14 * scale}px;
          `}
        >
          {subTitle}
        </Label>
        <Label
          css={`
            font-size: ${scale * 10}px;
            line-height: ${scale * 16}px;
          `}
        >
          {author}
        </Label>
        <Label
          css={`
            font-size: ${scale * 10}px;
            line-height: ${scale * 16}px;
          `}
        >{`${formatDateTime(new Date(), 'yyyy.MM.dd HH:mm')}`}</Label>
        <Label
          css={`
            font-size: ${scale * 10}px;
            line-height: ${scale * 16}px;
          `}
        >
          {location}
        </Label>
      </View>
    );
  },
);

export type WatermarkSceneType =
  | 'pre-inspection'
  | 'inspection'
  | 'construction'
  | 'delivery-check'
  | 'sampling-check';

const AuthorLabelMap: { [p in WatermarkSceneType]: string } = {
  'pre-inspection': '服务顾问',
  inspection: '检测技师',
  construction: '施工技师',
  'delivery-check': '质检员',
  'sampling-check': '抽检员',
};

export const TaskImageWatermark = memo(
  ({
    type,
    scale,
    licensePlateNo,
    title,
    title$,
    author,
    store,
    style,
  }: {
    type: WatermarkSceneType;
    scale?: number;
    licensePlateNo: string;
    title: string;
    title$?: BehaviorSubject<string>;
    author: string;
    store: string;
    style?: StyleProp<ViewStyle>;
  }) => {
    const [localTitle, setLocalTitle] = useState(title);
    useEffect(() => {
      if (title$ == null) return;
      const sub = title$.subscribe(s => {
        setLocalTitle(s);
      });
      return () => sub.unsubscribe();
    }, [title$]);

    return (
      <ImageWatermark
        title={licensePlateNo}
        subTitle={localTitle}
        author={`${AuthorLabelMap[type]}: ${author}`}
        location={store}
        scale={scale}
        style={style}
      />
    );
  },
);

const Label = styled.Text.attrs((props: any) => ({
  numberOfLines: 1,
  ...props,
}))`
  font-family: ${FontFamily.NotoSans.Light};
  font-size: 10px;
  line-height: 13px;
  color: #fff;
`;
